export var GraphqlMiddlewareOperation = /* @__PURE__ */ ((GraphqlMiddlewareOperation2) => {
  GraphqlMiddlewareOperation2["Query"] = "query";
  GraphqlMiddlewareOperation2["Mutation"] = "mutation";
  return GraphqlMiddlewareOperation2;
})(GraphqlMiddlewareOperation || {});
export const CLIENT_CONTEXT_PREFIX = "__gqlc_";
export const OPERATION_HASH_PREFIX = "__gqlh";
